import 'react-phone-input-2/lib/material.css';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { useEffect, useRef } from 'react';
import { cn, convertIntoArray, getContentKeyAccToLang } from '../../../utils/utils';
import { Chips, ErrorText, RowView, Text, ViewItems, PhoneInput } from '../../CorporateForm/components';
import Dropdown from '../../../components/Dropdown';
import { fontSizes } from '../../../constants/constants';
import CustomInput from '../../../components/CustomInput';
import Button from '../../../components/Button';
import dynamicfunction from '../../../utils/dynamicfunction';
import { useNavigate } from 'react-router';
import { logoutUser } from '../../../store/actions/authActions';
import { individual_contact_info_validation_schema } from '../../../validations_schemas/individual_contact_information_schema';
import { getIndContactInformationData, postIndContactInformation, saveIndKycContactInformation } from '../../../store/actions/individualAction';
import { integer_regex } from '../../../utils/functions';
import KeepValuesOnLanguageChange from '../../../components/KeepValuesOnLanguageChange';

const ContactInformation = ({ onDone }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isArabic, TextWeight } = dynamicfunction();

  const { individualContent, language } = useSelector((state) => state.content);
  const { ind_post_loading, ind_contact_information_data, ind_contact_information_dropdown_data } = useSelector((state) => state.individual);

  const { client_application_id, is_kyc, applicant_type } = useSelector((state) => state.constant);

  // Unsaved form values captured on language switch; in memory only, so a hard reload clears them.
  const draftValues = useRef(null);

  const getContent = (key) => {
    return getContentKeyAccToLang(individualContent?.contact_person_info?.data?.attributes, key, isArabic);
  };

  const is_ksa = (applicant_type === 'KSA Resident' || applicant_type === 'KSA National');
  const is_ksa_national = applicant_type === 'KSA National'
  const myArray = convertIntoArray(ind_contact_information_dropdown_data);

  useEffect(() => {
    getData();
  }, [language]);
  const getData = async () => {
    await dispatch(
      getIndContactInformationData(client_application_id),
    );
  }
  const onSubmit = (values) => {
    const api_data = {
      ...ind_contact_information_data,
      mobileNumber: values?.mobileNumber,
      phoneNumber: values?.phoneNumber,
      additionalPhoneNumber: values?.additionalPhoneNumber,
      haveAnotherPhoneNumber: values?.additionalPhoneNumber === '' || values?.additionalPhoneNumber === null ? false : true,
      emailAddress: values?.emailAddress,
      // confirmEmailAddress: values?.confirmEmailAddress,
      preferenceForContactId: values?.preferenceForContactId,
      ksaNationalCountryId: values?.ksaNationalCountryId?.id,
      nonKsaCountryId: values?.ksaNationalCountryId?.id,
      ksaNationalAddress: values?.ksaNationalAddress,
      nonKsaNationalAddress: values?.ksaNationalAddress,
      buildingNumber: values?.buildingNumber,
      nonKsaBuildingNumber: values?.buildingNumber,
      streetName: values?.streetName,
      nonKsaStreetName: values?.streetName,
      district: values?.district,
      nonKsaDistrict: values?.district,
      city: values?.city,
      nonKsaNationalCity: values?.city,
      postalCode: values?.postalCode,
      nonKsaNationalPostalCode: values?.postalCode,
      additionalNumber: values?.additionalNumber,
      nonKsaAdditionalNumber: values?.additionalNumber,
      unitNumber: values?.unitNumber,
      nonKsaUnitNo: values?.unitNumber,
      ksaNationalProvince: values?.ksaNationalProvince,
      nonKsaNationalProvince: values?.ksaNationalProvince,
    };

    dispatch(
      is_kyc
        ? saveIndKycContactInformation(api_data, (res) => {
          values?.isSaveExist ? navigate('/funds/available-funds') : onDone();
        })
        : postIndContactInformation(api_data, (res) => {
          values?.isSaveExist ? dispatch(logoutUser()) : onDone();
        }),
    );
  };

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={individual_contact_info_validation_schema}
        initialValues={draftValues.current ? {
          ...draftValues.current,
          // Re-pick dropdown objects from the refetched list so labels show in the new language.
          ksaNationalCountryId: myArray?.countryList?.find((item) => item.id === String(draftValues.current?.ksaNationalCountryId?.id)) ?? null,
        } : {
          mobileNumber: ind_contact_information_data?.mobileNumber ?? '',
          phoneNumber: ind_contact_information_data?.phoneNumber ?? '',
          additionalPhoneNumber: ind_contact_information_data?.additionalPhoneNumber ?? '',
          emailAddress: ind_contact_information_data?.emailAddress ?? '',
          preferenceForContactId: ind_contact_information_data?.preferenceForContactId?.map((item) => item?.toString()) ?? [],
          ksaNationalCountryId:
            (is_ksa ? is_ksa_national
              ? myArray?.countryList?.find((item) => item.id === String(ind_contact_information_data?.ksaNationalCountryId)) ??
              myArray?.countryList?.find((item) => item.id === String(194))
              : myArray?.countryList?.find((item) => item.id === String(ind_contact_information_data?.ksaNationalCountryId))
              : myArray?.countryList?.find((item) => item.id === String(ind_contact_information_data?.nonKsaCountryId))) ?? null,
          ksaNationalAddress:
            (is_ksa ? ind_contact_information_data?.ksaNationalAddress : ind_contact_information_data?.nonKsaNationalAddress) ?? '',
          buildingNumber: (is_ksa ? ind_contact_information_data?.buildingNumber : ind_contact_information_data?.nonKsaBuildingNumber) ?? '',
          streetName: (is_ksa ? ind_contact_information_data?.streetName : ind_contact_information_data?.nonKsaStreetName) ?? '',
          district: (is_ksa ? ind_contact_information_data?.district : ind_contact_information_data?.nonKsaDistrict) ?? '',
          city: (is_ksa ? ind_contact_information_data?.city : ind_contact_information_data?.nonKsaNationalCity) ?? '',
          postalCode: (is_ksa ? ind_contact_information_data?.postalCode : ind_contact_information_data?.nonKsaNationalPostalCode) ?? '',
          additionalNumber: (is_ksa ? ind_contact_information_data?.additionalNumber : ind_contact_information_data?.nonKsaAdditionalNumber) ?? '',
          unitNumber: (is_ksa ? ind_contact_information_data?.unitNumber : ind_contact_information_data?.nonKsaUnitNo) ?? '',
          ksaNationalProvince:
            (is_ksa ? ind_contact_information_data?.ksaNationalProvince : ind_contact_information_data?.nonKsaNationalProvince) ?? '',
          isSaveExist: false,
        }}
        onSubmit={(values) => {
          onSubmit(values);
        }}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({ handleSubmit, setFieldValue, values, setFieldTouched, touched, errors }) => {
          return (
            <div className=''>
              <KeepValuesOnLanguageChange onLanguageChange={(currentValues) => (draftValues.current = currentValues)} />
              <div className='gap-7 grid grid-cols-1 md:grid-cols-3 w-full'>
                <ViewItems className={cn(isArabic ? 'order-last' : 'order-first')}>
                  <PhoneInput
                    isRequired
                    label={getContent('mobile_no')}
                    labelColor={'text-text-grey'}
                    labelDivClass={'h-6 md:h-9 lg:h-6 leading-4'}
                    value={values?.mobileNumber}
                    onChange={(val) => {
                      setFieldValue('mobileNumber', val);
                      setFieldTouched('mobileNumber', true);
                    }}
                    isDisabled={!is_kyc}
                  />
                  <ErrorText text={getContent(touched?.mobileNumber ? errors?.mobileNumber : '')} />
                </ViewItems>
                <ViewItems>
                  <PhoneInput
                    label={getContent('phone_number')}
                    labelColor={'text-text-grey'}
                    labelDivClass={'h-6 md:h-9 lg:h-6 leading-4'}
                    value={values?.phoneNumber}
                    onChange={(val) => {
                      setFieldValue('phoneNumber', val);
                      setFieldTouched('phoneNumber', true, false);
                    }}
                    placeholder={getContent('enter_phone_number')}
                  />
                  <ErrorText text={getContent(touched?.phoneNumber ? errors?.phoneNumber : '')} />
                </ViewItems>
                <ViewItems className={cn(isArabic ? 'order-first' : 'order-last')}>
                  <PhoneInput
                    label={getContent('additional_mobile_number')}
                    labelColor={'text-text-grey'}
                    labelDivClass={'h-9 sm:h-6 md:h-9 lg:h-6 leading-4'}
                    value={values?.additionalPhoneNumber}
                    onChange={(val) => {
                      setFieldValue('additionalPhoneNumber', val);
                      setFieldTouched('additionalPhoneNumber', true, false);
                    }}
                  />
                  <ErrorText text={getContent(touched?.additionalPhoneNumber ? errors?.additionalPhoneNumber : '')} />
                </ViewItems>
              </div>

              <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                <CustomInput
                  label={getContent('email_address')}
                  placeholder={getContent('enter_email_address')}
                  isRounded
                  isRequired={true}
                  value={values?.emailAddress}
                  onChange={(e) => {
                    setFieldValue('emailAddress', e.target.value);
                    setFieldTouched('emailAddress', true, false);
                  }}
                  errorMessage={getContent(touched?.emailAddress ? errors?.emailAddress : '')}
                />
                {/* <CustomInput
                  isRounded
                  isRequired={true}
                  label={getContent('confirm_email_address')}
                  value={values?.confirmEmailAddress}
                  onChange={(e) => {
                    setFieldValue('confirmEmailAddress', e.target.value);
                    setFieldTouched('confirmEmailAddress', true, false);
                  }}
                  placeholder={getContent('enter_confirm_email_address')}
                  errorMessage={getContent(touched?.confirmEmailAddress ? errors?.confirmEmailAddress : '')}
                /> */}
                <div className='lg:w-full hidden lg:block'></div>
                <div className='lg:w-full hidden lg:block'></div>
              </RowView>

              <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                <div className='w-full'>
                  <Chips
                    isMulti
                    label={getContent('preferred_correspondence')}
                    value={values?.preferenceForContactId}
                    onChange={(e) => {
                      setFieldValue('preferenceForContactId', e);
                      setFieldTouched('preferenceForContactId', false);
                    }}
                    options={myArray?.preferenceForContact}
                  />
                  <ErrorText text={getContent(touched?.preferenceForContactId ? errors?.preferenceForContactId : '')} />
                </div>
                <div className='lg:w-full hidden lg:block'></div>
                <div className='lg:w-full hidden lg:block'></div>
              </RowView>

              {is_ksa ? (
                <Text
                  text={
                    <>
                      <Text
                        text={getContent('residence_outside_saudi')}
                        size={fontSizes.h18}
                        isTruncate={false}
                        weight={TextWeight.semiBold}
                        className={'block pt-3 sm:pt-5'}
                      />
                      <Text
                        text={getContent('residence_outside_saudi')}
                        size={fontSizes.h14}
                        isTruncate={false}
                        weight={TextWeight.medium}
                        className={'block pt-3 sm:pt-5'}
                      />
                    </>
                  }
                />
              ) : (
                <Text
                  text={getContent('residence_outside_saudi')}
                  size={fontSizes.h16}
                  isTruncate={false}
                  weight={TextWeight.semiBold}
                  className={'block pt-3 sm:pt-5'}
                />
              )}

              <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                <Dropdown
                  label={getContent('country')}
                  placeholder={getContent('select_country')}
                  options={myArray?.countryList}
                  selectedValue={values?.ksaNationalCountryId}
                  isDisabled={is_ksa_national}
                  valueKey={'name'}
                  isRequired
                  isSearch
                  onSelect={(val) => {
                    setFieldValue('ksaNationalCountryId', val);
                    setFieldTouched('ksaNationalCountryId', false);
                  }}
                  errorMessage={getContent(touched?.ksaNationalCountryId ? errors?.ksaNationalCountryId : '')}
                />
                <CustomInput
                  isRounded
                  isRequired={true}
                  label={getContent('address')}
                  maxLength={200}
                  value={values?.ksaNationalAddress}
                  onChange={(e) => {
                    setFieldValue('ksaNationalAddress', e.target.value);
                    setFieldTouched('ksaNationalAddress', true, false);
                  }}
                  placeholder={getContent('enter_address')}
                  errorMessage={getContent(touched?.ksaNationalAddress ? errors?.ksaNationalAddress : '')}
                />
                <CustomInput
                  isRounded
                  isRequired={true}
                  maxLength={50}
                  label={getContent('building_no')}
                  value={values?.buildingNumber}
                  onChange={(e) => {
                    setFieldValue('buildingNumber', e.target.value);
                    setFieldTouched('buildingNumber', true, false);
                  }}
                  placeholder={getContent('enter_building_no')}
                  isDisabled={is_ksa || ind_contact_information_data?.isBuildingNumberFetchedByNafath}
                  errorMessage={getContent(touched?.buildingNumber ? errors?.buildingNumber : '')}
                />
              </RowView>

              <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                <CustomInput
                  label={getContent('district')}
                  placeholder={getContent('enter_district')}
                  isRounded
                  isRequired={true}
                  maxLength={50}
                  value={values?.district}
                  onChange={(e) => {
                    setFieldValue('district', e.target.value);
                    setFieldTouched('district', true, false);
                  }}
                  isDisabled={is_ksa || ind_contact_information_data?.isDistrictFetchedByNafath}
                  errorMessage={getContent(touched?.district ? errors?.district : '')}
                />
                <CustomInput
                  isRounded
                  isRequired={true}
                  maxLength={50}
                  label={getContent('street_name')}
                  value={values?.streetName}
                  onChange={(e) => {
                    setFieldValue('streetName', e.target.value);
                    setFieldTouched('streetName', true, false);
                  }}
                  placeholder={getContent('enter_street_name')}
                  isDisabled={is_ksa || ind_contact_information_data?.isStreetNameFetchedByNafath}
                  errorMessage={getContent(touched?.streetName ? errors?.streetName : '')}
                />
                <CustomInput
                  isRounded
                  label={getContent('unit_no')}
                  value={values?.unitNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || integer_regex.test(value)) {
                      setFieldValue('unitNumber', value);
                      setFieldTouched('unitNumber', true, false);
                    }
                  }}
                  maxLength={25}
                  placeholder={getContent('enter_unit_no')}
                  isDisabled={is_ksa || ind_contact_information_data?.isUnitNoFetchedByNafath}
                  errorMessage={getContent(touched?.unitNumber ? errors?.unitNumber : '')}
                />
              </RowView>

              <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                <CustomInput
                  isRounded
                  isRequired={true}
                  maxLength={11}
                  label={getContent('additional_no')}
                  value={values?.additionalNumber}
                  onChange={(e) => {
                    setFieldValue('additionalNumber', e.target.value);
                    setFieldTouched('additionalNumber', true, false);
                  }}
                  placeholder={getContent('enter_additional_no')}
                  isDisabled={is_ksa || ind_contact_information_data?.isAdditionalNumberFetchedByNafath}
                  errorMessage={getContent(touched?.additionalNumber ? errors?.additionalNumber : '')}
                />
                <CustomInput
                  isRounded
                  isRequired={true}
                  maxLength={11}
                  label={getContent('zip_code')}
                  value={values?.postalCode}
                  onChange={(e) => {
                    setFieldValue('postalCode', e.target.value);
                    setFieldTouched('postalCode', true, false);
                  }}
                  placeholder={getContent('enter_zip_code')}
                  maxLength={10}
                  isDisabled={is_ksa || ind_contact_information_data?.isPostalCodeFetchedByNafath}
                  errorMessage={getContent(touched?.postalCode ? errors?.postalCode : '')}
                />
                <CustomInput
                  isRounded
                  isRequired={true}
                  maxLength={20}
                  label={getContent('city')}
                  value={values?.city}
                  onChange={(e) => {
                    setFieldValue('city', e.target.value);
                    setFieldTouched('city', true, false);
                  }}
                  placeholder={getContent('enter_city')}
                  isDisabled={is_ksa || ind_contact_information_data?.isCityFetchedByNafath}
                  errorMessage={getContent(touched?.city ? errors?.city : '')}
                />
              </RowView>

              {/* <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                <CustomInput
                  label={getContent('province_state_region')}
                  placeholder={getContent('enter_province_state_region')}
                  isRounded
                  isRequired={true}
                  value={values?.ksaNationalProvince}
                  onChange={(e) => {
                    setFieldValue('ksaNationalProvince', e.target.value);
                    setFieldTouched('ksaNationalProvince', true, false);
                  }}
                  errorMessage={getContent(touched?.ksaNationalProvince ? errors?.ksaNationalProvince : '')}
                  maxLength={20}
                />
              </RowView> */}

              <div className='w-full h-0.5 bg-border mt-3 sm:mt-5'></div>

              <RowView className='gap-3 sm:gap-7 pt-3 sm:pt-5'>
                <Button
                  text={getContent('save_proceed')}
                  color={'text-white hover:text-primary '}
                  bgColor='bg-primary hover:bg-transparent hover:border-primary'
                  className={'border border-transparent w-44 px-0 text-center'}
                  loading={ind_post_loading}
                  isDisabled={ind_post_loading}
                  onClick={() => {
                    setFieldValue('isSaveExist', false);
                    handleSubmit();
                  }}
                />
                <Button
                  text={getContent('save_exit')}
                  color={'text-primary hover:text-white'}
                  bgColor='bg-white hover:bg-primary'
                  className={'border border-primary w-44 px-0 text-center'}
                  isDisabled={ind_post_loading}
                  onClick={() => {
                    setFieldValue('isSaveExist', true);
                    handleSubmit();
                  }}
                />
              </RowView>
            </div>
          );
        }}
      </Formik >
    </>
  );
};

export default ContactInformation;
